module.exports = __webpack_public_path__ + "static/media/csr_3_bersama_chiki.a7cde6b0.jpg";